// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"138fea6d","404":"0bd3eb67","787":"b671be76"}[chunkId] + ".chunk.js";
};